import { createFieldValidator } from "../../error/createFieldValidator";
import { useSignupFlowErrorStore } from "../hooks/useSignUpFlowErrorStore";
import { SignupFlowSlug } from "../constants";

import { signupFieldValidations } from "./signupFieldValidations";
import { FieldKey } from "@./state";

export const validateSignUpField = createFieldValidator<FieldKey, SignupFlowSlug>(
  useSignupFlowErrorStore.getState(),
  signupFieldValidations,
);
